import {
    LIST_INTERMEDIATES,
    LIST_INTERMEDIATES_SUCCESS,
    LIST_INTERMEDIATES_ERROR,
    ADD_INTERMEDIATES,
    SAVE_INTERMEDIATES,
    SAVE_INTERMEDIATES_SUCCESS,
    SAVE_INTERMEDIATES_ERROR,
    EDIT_INTERMEDIATES,
    UPDATE_INTERMEDIATES,
    UPDATE_INTERMEDIATES_SUCCESS,
    UPDATE_INTERMEDIATES_ERROR,
    DELETE_INTERMEDIATES,
    DELETE_INTERMEDIATES_SUCCESS,
    DELETE_INTERMEDIATES_ERROR
} from '../types';

//Cada reducer tiene su propio state
const initialState = {
    intermediates: null,
    error: null,
    loading: false,
    intermediateSelected: null,
    isEdit: false,
    loadingSave: false,
    errorSave: null
}

export default function(state = initialState, action) {
    switch(action.type){
        case LIST_INTERMEDIATES:
            return {
                ...state,
                loading: true
            }
        case LIST_INTERMEDIATES_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case LIST_INTERMEDIATES_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                intermediates: action.payload
            }
        case SAVE_INTERMEDIATES:
        case DELETE_INTERMEDIATES:
            return {
                ...state,
                isEdit: false,
                loadingSave: true
            }
        case UPDATE_INTERMEDIATES:
            return {
                ...state,
                loadingSave: true
            }
        case SAVE_INTERMEDIATES_ERROR:
        case UPDATE_INTERMEDIATES_ERROR:
        case DELETE_INTERMEDIATES_ERROR:
            return {
                ...state,
                loadingSave: false,
                errorSave: action.payload
            }
        case SAVE_INTERMEDIATES_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                intermediates: [action.payload, ...state.intermediates]
            }
        case ADD_INTERMEDIATES:
            return {
                ...state,
                intermediateSelected: null,
                isEdit: false
            }
        case EDIT_INTERMEDIATES:
            return {
                ...state,
                intermediateSelected: action.payload,
                isEdit: true
            }
        case UPDATE_INTERMEDIATES_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                intermediates: state.intermediates.map(intermediate => 
                    intermediate.id === action.payload.id ? intermediate = action.payload : intermediate
                ),
                intermediateselected: null
            }
        case DELETE_INTERMEDIATES_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                intermediates: state.intermediates.filter( intermediate => intermediate.id !== action.payload)
            }
        default:
            return state;
    }
}